<!--当前用户-->
<template>
  <div class="sys_cur_user_box">
    <div
      style="margin-right: 20px; border-right: 1px solid #fff; padding-right: 20px; color: #fff;font-size: 16px;"
    >
      {{ cur_time }}
    </div>

    <el-dropdown>
      <span style="color: #fff">
        <i
          class="el-icon-user-solid"
          style="position: relative;top: 3px; font-size: 20px;color:#fff;"
        ></i>
        <span style="font-size: 14px;margin-left: 2px;">{{
          get_cur_user
        }}</span>
        <i class="el-icon-caret-bottom"></i>
      </span>

      <el-dropdown-menu slot="dropdown" class="default_dropdown">
        <el-dropdown-item @click.native="before_do_logout"
          >退出登录</el-dropdown-item
        >
        <el-dropdown-item @click.native="onUpdatePw">修改密码</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <update-pw ref="updatePw"></update-pw>
  </div>
</template>

<script>
import UpdatePw from "../../../components/common/sys_common/sys_header_banner/sys_user_updatePw.vue";
export default {
  name: "sys_cur_user",
  components: { UpdatePw },
  computed: {
    get_cur_user: function() {
      if (this.GLOBAL.common_tool.get_user_info()) {
        let user_info = this.GLOBAL.common_tool.get_user_info();
        return user_info.user ? user_info.user.name : "";
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      cur_time: ""
    };
  },

  created() {
    setInterval(() => {
      this.set_cur_time();
    }, 1000);
  },

  methods: {
    set_cur_time() {
      let date = new Date();
      let d =
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日";
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let mm = date.getMinutes();
      mm = mm < 10 ? "0" + mm : mm;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      let t = h + ":" + mm + ":" + s;
      this.cur_time = d + " " + t;
    },

    /**
     * 退出登录
     */
    do_logout() {
      this.$router.push("/login");
    },
    //修改密码
    onUpdatePw() {
      this.$refs.updatePw.init();
    },
    before_do_logout() {
      this.$confirm("确定退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.do_logout();
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.sys_cur_user_box {
  position: absolute;
  z-index: 10;
  right: 20px;
  top: 18px;

  display: flex;
  flex-direction: row;
  align-items: center;

  .title {
    font-weight: bold;
    font-size: 24px;
    color: #fff;
    margin-left: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/studio/sub_systems/sub_system_common_components/sys_cur_user.vue